
  function valueChanged(show) {
    var checked_check = false;

    $("input[name='attributes[fund_TICK]']").each(function (i, e) {
      
      // Code handling just allow user click to one checkbox at a time
      $(e).on("click", (e) => {
        $("input[name='attributes[fund_TICK]']").not($(e.target)).prop('checked', false);  
      })
      
      // If element is checked show form
      if ($(this).is(':checked')) {
        checked_check = true;
      }
      
    });

    if (checked_check) {
      $('#next_content').removeClass('hidden');
      $('.section_checkbox').addClass('hidden');
      $('.' + show).removeClass('hidden');
    } else {
      $('#next_content').addClass('hidden');
    }
  }

  function valueChanged1() {
    if ($('.coupon_question1').is(':checked')) {
      $('.custom_inputs1').removeClass('hidden');
    } else {
      $('.custom_inputs1').addClass('hidden');
    }
  }

  $(document).on('change', 'input[name="attributes[trustee_TICK]"]', function () {
    if ($('input[name="attributes[trustee_TICK]"]:checked').val() == 'State_Trustees') {
      $('#next_content3').removeClass('hidden');
      $('#custom_inputs_state').removeClass('hidden');
      $('#custom_inputs_capital').addClass('hidden');
      $('#custom_inputs_public').addClass('hidden');
      $('#custom_inputs_other').addClass('hidden');
    } else if ($('input[name="attributes[trustee_TICK]"]:checked').val() == 'Capital_Guardians') {
      $('#next_content3').removeClass('hidden');
      $('#custom_inputs_capital').removeClass('hidden');
      $('#custom_inputs_state').addClass('hidden');
      $('#custom_inputs_public').addClass('hidden');
      $('#custom_inputs_other').addClass('hidden');
    } else if ($('input[name="attributes[trustee_TICK]"]:checked').val() == 'Public_Trustee') {
      $('#next_content3').removeClass('hidden');
      $('#custom_inputs_public').removeClass('hidden');
      $('#custom_inputs_state').addClass('hidden');
      $('#custom_inputs_capital').addClass('hidden');
      $('#custom_inputs_other').addClass('hidden');
    } else if ($('input[name="attributes[trustee_TICK]"]:checked').val() == 'Other') {
      $('#next_content3').removeClass('hidden');
      $('#custom_inputs_other').removeClass('hidden');
      $('#custom_inputs_state').addClass('hidden');
      $('#custom_inputs_capital').addClass('hidden');
      $('#custom_inputs_public').addClass('hidden');
    } else {
    }
  });

/*****Add attributes to order*****/
/*
  let attributes = [];
  document.querySelectorAll('#next_content [form="cart"]').forEach(function (elm) {

    elm.addEventListener('change', function (e) {
      attributes.push(`${e.target.getAttribute('id')}:${e.target.value}`);
    })

  })

  document.querySelector('#CartDrawer-Checkout').addEventListener('click', function (e) {
    e.preventDefault();

    let ObjectAttributes = {};
    attributes.forEach(item => {
        let parts = item.split(':');
        let key = parts[0];
        let value = parts[1];
        ObjectAttributes[key] = value;
    });

    const body = JSON.stringify({ attributes: ObjectAttributes });
    fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
    setTimeout(() => {
      location.href = '/checkout/';
    }, 1200)

 })
*/
  